/* global Provider */
import React, { Component } from 'react';
import ReportPage from './ReportPage';
import DisclosureData from '../DisclosureData';
import _ from 'underscore';
import RankTable from '../RankTable';

class DisclosuresPage extends Component {
    render() {
        let funds = Provider.getFunds();
        var includesYourPath = _.find(funds, (item) => {
            return item.id === "LifetimeHybridAgg" || item.display.indexOf('YourPath') > -1;
        });    

        if (!this.props.portrait && !this.props.quartiles) {
            return [
                <ReportPage {...this.props} title="Additional Disclosures" pageNumber={this.props.pageNumber} className="disclosures-page" subtitle="Target-Date Fund Additional Information">
                    <div className="mt-1">&nbsp;</div>
                    <DisclosureData {...this.props} limitToSelected={true} forReport={true}/>
                    <p className="footnote">
                        All funds: Investment objective is Asset Allocation. Daily Liquidity. Principal not guaranteed. The tax consequences of owning shares of the funds will vary depending on whether you
                        own them through a taxable or tax-deferred account. Tax consequences result from distribution by the funds of dividend and interest income they have received or capital gains they
                        have generated through their investment activities. Tax consequences also may result when investors sell fund shares after th e net asset value has increased or decreased. The fund’s
                        prospectus contains this and other information, and should be read carefully before investing.                     
                    </p>
                    <p className="footnote">Source: Morningstar</p>

                    {includesYourPath ? <p className="footnote">
                        ***American Century Investments is not affiliated with any other listed investment company.
                    </p>: null }                   
                </ReportPage>,
                <ReportPage {...this.props} title="Additional Disclosures" pageNumber={this.props.pageNumber + 1} className="disclosures-page" subtitle="Target-Date Fund Additional Information">
                    <div className="mt-4">
                        <RankTable {...this.props}/>
                    </div>
                </ReportPage>
            ]
        } else {
            return <ReportPage {...this.props} title="Additional Disclosures" pageNumber={this.props.pageNumber} className="disclosures-page" subtitle="Target-Date Fund Additional Information">
                <div className="mt-1">&nbsp;</div>
                <DisclosureData {...this.props} limitToSelected={true} forReport={true}/>
                <p className="footnote">
                    All funds: Investment objective is Asset Allocation. Daily Liquidity. Principal not guaranteed. The tax consequences of owning shares of the funds will vary depending on whether you
                    own them through a taxable or tax-deferred account. Tax consequences result from distribution by the funds of dividend and interest income they have received or capital gains they
                    have generated through their investment activities. Tax consequences also may result when investors sell fund shares after th e net asset value has increased or decreased. The fund’s
                    prospectus contains this and other information, and should be read carefully before investing.                     
                </p>
                <p className="footnote">Source: Morningstar</p>

                {includesYourPath ? <p className="footnote">
                    ***American Century Investments is not affiliated with any other listed investment company.
                </p>: null }   

              
                                             
            </ReportPage>,
                <ReportPage {...this.props} title="Additional Disclosures" pageNumber={this.props.pageNumber + 1} className="disclosures-page" subtitle="Target-Date Fund Additional Information">
                    <div className="mt-4">
                        <RankTable {...this.props}/>
                    </div>
                </ReportPage>

            
        }  
    }
}

export default DisclosuresPage;
